<template>
    <div>
        <div class="border-bottom">
            <div class="container py-4">
                <div class="row justify-content-around">
                    <div
                        :key="g.title"
                        v-for="g in button_list"
                        class="row justify-content-center my-1"
                    >
                        <button
                            type="button"
                            class="btn ml-3 mr-3"
                            v-bind:class="
                                isActive(g.title)
                                    ? 'btn-secondary'
                                    : 'btn-outline-secondary'
                            "
                            @click="changeActiveGallery(g.title)"
                        >
                            <div class="m-1">
                                View {{ g.title }} Photos
                                <div
                                    v-if="g.description"
                                    style="text-align:center"
                                >
                                    {{ g.description }}
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid" style="margin-top:10vh;">
            <button
                v-show="!isActive(defaultGalleryTitle)"
                type="button"
                class="btn link ml-3 mr-3 back-button"
                @click="changeActiveGallery(null)"
            >
                <i class="fas fa-chevron-left"></i> Back to Main Gallery
            </button>
            <div :key="g.title" v-for="g in galleryList">
                <Gallery
                    v-show="isActive(g.title)"
                    :group_key="group_key"
                    :gallery="g"
                />
            </div>
            <div v-html="renderPicturesView" v-if="noSelectedGallery" ></div>
        </div>
    </div>
</template>

<script>
import Gallery from "./Gallery.vue";

const DEFAULT_GALLERY_TITLE = "Gallery";

export default {
    name: "GalleryList",
    props: {
        galleryList: Array,
        renderPicturesView: String
    },
    components: {
        Gallery
    },
    data() {
        return { activeGalleryTitle: null };
    },
    computed: {
        selected() {
            if (this.activeGalleryTitle !== null) {
                return this.activeGalleryTitle;
            }
            if (this.galleryList !== null && this.galleryList.length > 0) {
                return DEFAULT_GALLERY_TITLE;
            }
            return null;
        },
        button_list() {
            return this.galleryList.filter(
                o => o.title != DEFAULT_GALLERY_TITLE
            );
        },
        group_key() {
            return this.selected === DEFAULT_GALLERY_TITLE ? "year" : "day";
        },
        defaultGalleryTitle() {
            return DEFAULT_GALLERY_TITLE;
        },
        noSelectedGallery() {
            return (
                this.selected === DEFAULT_GALLERY_TITLE || this.selected == null
            );
        }
    },
    methods: {
        isActive(galleryTitle) {
            return this.selected ? galleryTitle === this.selected : false;
        },
        changeActiveGallery(galleryTitle) {
            if (this.activeGalleryTitle !== galleryTitle) {
                this.activeGalleryTitle = galleryTitle;
                return;
            }
            this.activeGalleryTitle = null;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.back-button {
    margin-bottom: 3vh;
}

.fa-chevron-left {
    margin-right: 5px;
}
</style>
